module.exports = __webpack_public_path__ + "static/media/biohazard.1dd89c77.svg";